import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { HomeBgImg, HomeBgLightImg, LogoBigImg } from "@/assets"
import { clearAuthData } from "@/helpers/clearAuthData"
import { openTgLink } from "@/helpers/openTgLink"
import { ROUTES } from "@/helpers/routes"
import { getTgWebApp } from "@/helpers/tgWebApp"
import { useCheckTutorial } from "@/hooks/useCheckTutorial"
import { useModals } from "@/modals"
import { useAppDispatch, useAppSelector } from "@/store"
import { AppSelectors } from "@/store/slices/app"
import { setIsAuthorized } from "@/store/slices/player"
import { Button } from "@/ui/Button"
import styles from "./Home.module.scss"
import { FindMatch, PlayTon, WithFriends } from "./ui"

export const Home: FC = () => {
  const navigate = useNavigate()

  useCheckTutorial()

  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const { openModal } = useModals()

  const isTMA = useAppSelector(AppSelectors.selectIsTMA())

  const handleOptions = () => {
    openModal("settings")
  }

  const handleShop = () => {
    navigate(ROUTES.SHOP)
  }

  const handleWallet = () => {
    navigate(ROUTES.WALLET)
  }

  const handleReferrals = () => {
    navigate(ROUTES.REFERRALS)
  }

  // const handleQuests = () => {
  //   navigate(ROUTES.QUESTS)
  // }

  const handleLabrApp = () => {
    const tgWebApp = getTgWebApp()
    tgWebApp?.unlockOrientation?.()
    openTgLink(import.meta.env.VITE_LABR_APP)
    tgWebApp?.close()
  }

  const handleLogout = () => {
    clearAuthData()
    dispatch(setIsAuthorized(false))
  }

  const handleHowItWorks = () => {
    openModal("howItWorks")
  }

  return (
    <div className={styles.Home}>
      <div className={styles.Home_logo}>
        <img src={LogoBigImg} alt={t("home.logoAlt")} />
      </div>
      <div className={styles.Home_container}>
        <div className={styles.Home_header}>
          <div className={styles.Home_header_item}>
            {isTMA && <Button.Back onClick={handleLabrApp} />}
            {!isTMA && (
              <Button onClick={handleLogout}>{t("button.logout")}</Button>
            )}
          </div>
          <div className={styles.Home_header_item} />
        </div>
        <div className={styles.Home_bottom}>
          <div className={styles.Home_bottom_cell}>
            <Button
              className={styles.Home_bottom_button}
              styles="green"
              onClick={handleHowItWorks}
            >
              {t("howItWorks.title")}
            </Button>
          </div>
          <div className={styles.Home_bottom_cell}>
            {/* <Button
              className={styles.Home_bottom_button}
              styles="yellow-3d"
              onClick={handleQuests}
            >
              {t("quests.title")}
            </Button> */}
            <Button
              className={styles.Home_bottom_button}
              styles="yellow-3d"
              onClick={handleShop}
            >
              {t("shop.title")}
            </Button>
            <Button
              className={styles.Home_bottom_button}
              styles="yellow-3d"
              onClick={handleWallet}
            >
              {t("wallet.title")}
            </Button>
            <Button
              className={styles.Home_bottom_button}
              styles="yellow-3d"
              onClick={handleReferrals}
            >
              {t("referrals.title")}
            </Button>
            <Button
              className={styles.Home_bottom_button}
              styles="green"
              onClick={handleOptions}
            >
              {t("options")}
            </Button>
          </div>
        </div>
      </div>
      <div className={styles.Home_content}>
        <div className={styles.Home_bg}>
          <img src={HomeBgImg} alt="home bg" />
        </div>
        <div className={styles.Home_overlayDark} />
        <div className={styles.Home_overlayLight}>
          <div className={clsx(styles.Home_overlayLight_item, styles.item_1)} />
          <div className={clsx(styles.Home_overlayLight_item, styles.item_2)} />
        </div>
        <div className={styles.Home_bgLight}>
          <HomeBgLightImg />
        </div>
        <div className={styles.Home_floor} />
        <div className={styles.Home_menu}>
          <WithFriends className={styles.Home_menu_item} />
          <FindMatch className={styles.Home_menu_item} />
          <PlayTon className={styles.Home_menu_item} />
        </div>
      </div>
    </div>
  )
}
